/* Cafe Passport product page: bundle tiers, holder add-on, set widget, extras, sticky bar. */
(function () {
  var dataEl = document.querySelector('[data-cp-data]');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var root = dataEl.closest('.cp');

  function money(c) {
    var f = D.moneyFormat || '${{amount}}';
    var a = (c / 100).toFixed(2);
    var withCommas = a.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }
  function tierTotal(n, unit) { return n >= 3 ? Math.round(unit * n * 0.75) : n === 2 ? Math.round(unit * n * 0.8) : unit * n; }
  function cart() {
    if (window.CPCart) return window.CPCart;
    return { add: function (lines) {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: l.quantity }; }) })
      }).then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; });
    } };
  }
  function showErr(scope, err) {
    var e = scope.querySelector('[data-cp-err]');
    if (!e) return;
    e.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
    e.hidden = false;
  }
  function busy(btn, on, label) {
    btn.disabled = on;
    if (on) { btn.dataset.label = btn.innerHTML; btn.textContent = 'Adding...'; }
    else if (label) btn.innerHTML = label; else if (btn.dataset.label) btn.innerHTML = btn.dataset.label;
  }

  /* Gallery */
  var track = root.querySelector('[data-cp-track]');
  var thumbs = root.querySelectorAll('[data-cp-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var s = root.querySelector('#cp-slide-' + t.dataset.cpThumb);
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  });
  if (track && thumbs.length) {
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth) + 1;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(+t.dataset.cpThumb === i)); });
    }, { passive: true });
  }

  /* Buy box */
  var fmt = 'book';
  var priceEl = root.querySelector('[data-cp-price]');
  var tiers = root.querySelector('[data-cp-tiers]');
  var holderWrap = root.querySelector('[data-cp-holder-wrap]');
  var holderBox = root.querySelector('[data-cp-holder]');
  var form = root.querySelector('[data-cp-form]');
  var atc = root.querySelector('[data-cp-atc]');
  var stickySub = root.querySelector('[data-cp-sticky-sub]');

  function tier() { var c = root.querySelector('[data-cp-tier]:checked'); return c ? +c.value : 1; }
  function holderOn() { return fmt === 'book' && holderBox && holderBox.checked && D.holder; }
  function total() {
    if (fmt === 'pdf') return D.digi.price;
    return tierTotal(tier(), D.phys.price) + (holderOn() ? D.holder.price : 0);
  }
  function refresh() {
    var t = total();
    if (priceEl) {
      priceEl.textContent = money(fmt === 'pdf' ? D.digi.price : D.phys.price);
      priceEl.classList.toggle('cp-hide', fmt === 'book' && !!tiers);
    }
    if (tiers) tiers.classList.toggle('cp-hide', fmt === 'pdf');
    if (holderWrap) holderWrap.classList.toggle('cp-hide', fmt === 'pdf');
    if (stickySub) stickySub.textContent = (fmt === 'pdf' ? 'PDF' : tier() + (tier() > 1 ? ' books' : ' book')) + ' · ' + money(t);
    var available = fmt === 'pdf' ? D.digi && D.digi.available : D.phys.available;
    if (atc) {
      atc.disabled = !available;
      atc.textContent = available ? 'Add to cart' : 'Sold out';
    }
  }
  root.querySelectorAll('[data-cp-tier]').forEach(function (r) { r.addEventListener('change', refresh); });
  if (holderBox) holderBox.addEventListener('change', refresh);
  var dlg = root.querySelector('[data-cp-holder-dlg]');
  var dlgOpen = root.querySelector('[data-cp-holder-open]');
  if (dlg && dlgOpen && dlg.showModal) {
    var dlgBtn = dlg.querySelector('[data-cp-dlg-toggle]');
    var setDlgBtn = function () { dlgBtn.textContent = holderBox && holderBox.checked ? 'Remove from my order' : 'Add to my order'; };
    dlgOpen.addEventListener('click', function () { setDlgBtn(); dlg.showModal(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-cp-dlg-close]')) dlg.close(); });
    dlgBtn.addEventListener('click', function () {
      if (holderBox) { holderBox.checked = !holderBox.checked; refresh(); }
      dlg.close();
    });
  }
  root.querySelectorAll('[data-cp-fmt]').forEach(function (r) {
    r.addEventListener('change', function () { fmt = r.value; refresh(); });
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = form.querySelector('[data-cp-err]'); if (err) err.hidden = true;
      var lines;
      if (fmt === 'pdf') lines = [{ id: D.digi.id, quantity: 1, product_type: D.type, requires_shipping: false }];
      else {
        lines = [{ id: D.phys.id, quantity: tier(), product_type: D.type, requires_shipping: true }];
        if (holderOn()) lines.push({ id: D.holder.id, quantity: 1, product_type: 'Accessories', requires_shipping: true });
      }
      busy(atc, true);
      cart().add(lines).then(function () { busy(atc, false); refresh(); })
        .catch(function (x) { busy(atc, false); refresh(); showErr(form, x); });
    });
  }
  refresh();

  /* Sticky bar */
  var sticky = root.querySelector('[data-cp-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    var seen = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) seen = true;
        var on = !en.isIntersecting && seen && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        var b = sticky.querySelector('[data-cp-sticky-btn]'); if (b) b.tabIndex = on ? 0 : -1;
      });
    }).observe(atc);
    sticky.querySelector('[data-cp-sticky-btn]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else atc.click();
    });
  }

  /* Complete your set */
  var setBox = document.querySelector('[data-cp-setbox]');
  if (setBox) {
    var boxes = setBox.querySelectorAll('[data-cp-set]');
    if (boxes[1]) boxes[1].checked = true;
    var sBtn = setBox.querySelector('[data-cp-set-btn]');
    var sticker = +setBox.dataset.sticker;
    var h2 = setBox.querySelector('h2');
    var offer = document.createElement('div');
    offer.className = 'cp-offer';
    offer.innerHTML = '<div class="cp-offer__chip" data-n="2"><b>20% OFF</b><span>2 books</span></div>' +
      '<div class="cp-offer__chip" data-n="3"><b>25% OFF</b><span>3+ books</span></div>' +
      '<p class="cp-offer__plus">Plus free shipping' + (sticker ? ' and free sticker sheets' : '') + '</p>';
    if (h2) h2.insertAdjacentElement('afterend', offer);
    var chips = offer.querySelectorAll('.cp-offer__chip');
    function rowPrices(pct) {
      var n = pct === 0.25 ? 3 : pct === 0.2 ? 2 : 0;
      chips.forEach(function (c) { c.classList.toggle('is-on', +c.dataset.n === n); });
    }
    function setState() {
      var picked = [].filter.call(boxes, function (b) { return b.checked; });
      var n = picked.length;
      var full = picked.reduce(function (a, b) { return a + +b.dataset.price; }, 0);
      var pay = n >= 3 ? Math.round(full * 0.75) : n === 2 ? Math.round(full * 0.8) : full;
      setBox.querySelector('[data-cp-set-count]').textContent = n + (n === 1 ? ' book' : ' books');
      setBox.querySelector('[data-cp-set-total]').textContent = money(pay);
      setBox.querySelector('[data-cp-set-compare]').textContent = pay < full ? money(full) : '';
      rowPrices(n >= 3 ? 0.25 : n === 2 ? 0.2 : 0);
      var perk = setBox.querySelector('[data-cp-set-perk]');
      perk.hidden = false;
      if (n >= 2) perk.textContent = (n >= 3 ? '25%' : '20%') + ' off + free shipping' + (sticker ? ' + ' + n + ' free sticker sheets' : '') + (n === 2 ? '. Add 1 more for 25% off.' : '');
      else perk.textContent = n === 1 ? 'Add 1 more book for 20% off + free shipping' : 'Pick 2 books for 20% off + free shipping';
      sBtn.disabled = n < 1;
      sBtn.textContent = n < 1 ? 'Select a book' : 'Add to cart';
      return picked;
    }
    boxes.forEach(function (b) { b.addEventListener('change', setState); });
    setState();
    sBtn.addEventListener('click', function () {
      var picked = setState();
      var lines = picked.map(function (b) { return { id: +b.value, quantity: 1, product_type: b.dataset.type, requires_shipping: true }; });
      busy(sBtn, true);
      cart().add(lines).then(function () { busy(sBtn, false); setState(); })
        .catch(function (x) { busy(sBtn, false); setState(); showErr(setBox, x); });
    });
  }

  /* Extras + full kit */
  document.querySelectorAll('[data-cp-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var ids = b.dataset.cpAdd.split(',');
      var lines = ids.map(function (id) {
        var book = +id === D.phys.id;
        return { id: +id, quantity: 1, product_type: book ? D.type : 'Accessories', requires_shipping: true };
      });
      var scope = b.closest('.cp-kit, .cp-x') || b.parentNode;
      busy(b, true);
      cart().add(lines).then(function () { busy(b, false, '✓ Added'); setTimeout(function () { busy(b, false); }, 2000); })
        .catch(function (x) { busy(b, false); showErr(scope, x); });
    });
  });

  /* Videos only play when on screen */
  var vids = document.querySelectorAll('[data-cp-lazyvid]');
  if (vids.length && 'IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { vo.observe(v); });
  }
})();
